// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"_159USjFvbwHhanKzJAM5nO","link":"nfbetyiSR1YriGW_5dkS6","buttonMargin":"_3Ldz18plWJl5DN5SV_PwXD","smallNote":"_3lYnLm0HIXG3mmky-ZqPqx"};